import { FortStatusMdl, proposalResMdl } from './proposalResMdl';
export class FortPaymentReq {
    public signature: string;
    public command: string;
    public merchant_reference: string;
    public amount: string;
    public access_code: string;
    public merchant_identifier: string;
    public currency: string;
    public language: string;
    public customer_email: string;
    public payment_option: string;
    public sadad_olp: string;
    public eci: string;
    public order_description: string;
    public dynamic_descriptor: string;
    public return_url: string;
    public customer_ip: string;
    public customer_name: string;
    public SurplusAmount:number;
    public st: FortStatusMdl;
    public trObj: proposalResMdl;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/FortPaymentReq.ts